<template>
  <Button
    v-if="meta.showBasket"
    as="router-link"
    :to="props.basketRoute"
    :loading="
      !basketMeta.isAvailable &&
      (basketMeta.isLoading || basketMeta.isProcessing) &&
      sessionMeta.isAuthenticated
    "
    variant="ghost"
    size="lg"
    icon="shopping-bag-02"
  >
    <Transition name="label-slide">
      <i18n-t
        v-if="count > 0"
        keypath="cart.basket_count"
        scope="global"
        :plural="count"
        tag="span"
        class="hidden px-1 md:inline"
      >
        <template #[`count`]>
          <Transition name="count-slide" mode="out-in">
            <span
              :key="count"
              data-testid="basket-action-count"
              class="inline-block"
              :class="count < 10 ? 'min-w-2.5' : 'min-w-5'"
            >
              {{ count }}
            </span>
          </Transition>
        </template>
      </i18n-t>
    </Transition>
  </Button>
</template>
<script lang="ts" setup>
// --- external
import { computed } from "vue";

// --- internal
import { useBasket, useSession } from "@upmind-automation/headless";
import { useHeader } from "../../../components/header/useHeader";

// --- components
import { Button } from "@upmind-automation/upmind-ui";

// --- types
import type { BasketActionProps } from "./types";

// -----------------------------------------------------------------------------

const props = defineProps<BasketActionProps>();

const { meta: sessionMeta } = useSession();

const { count, meta: basketMeta } = useBasket();
const { meta: headerMeta } = useHeader();

const meta = computed(() => ({
  // the chrome decides whether a basket shortcut belongs in the header
  showBasket: !!props.basketRoute && headerMeta.value.showBasket
}));
</script>

<style scoped>
.count-slide-enter-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.count-slide-leave-active {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.count-slide-enter-from {
  transform: translateY(20px);
  opacity: 0;
}

.count-slide-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}

.label-slide-enter-active {
  transition: all 0.3s ease;
}

.label-slide-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
  width: 0;
  margin: 0;
  padding: 0;
}

.label-slide-enter-from,
.label-slide-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
